import React from 'react';
import { SimulationConfig } from './types';

interface SimulationHeaderProps {
  config: SimulationConfig;
  currentRgb: string;
  ballCount: number;
  ringsLeft: number;
  bounceCount: number;
  isEscape: boolean;
}

export const SimulationHeader: React.FC<SimulationHeaderProps> = ({ config, currentRgb, ballCount, ringsLeft, bounceCount, isEscape }) => {
  const showBadge = !(isEscape && (config.ringCounterStyle === 'CENTER' || config.escapeTimeChallengeMode));
  const title = config.mode === 'SPAWNER' ? config.spawnerTitle : config.mode === 'DRAWER' ? config.drawerTitle : config.mode === 'ESCAPE' ? config.escapeTitle : config.trailTitle;

  return (
    <div className="absolute top-6 left-1/2 -translate-x-1/2 pointer-events-none text-center z-10 w-full px-4">
      <h1 className="font-black uppercase tracking-tighter text-2xl mb-1 transition-all duration-300" style={{ color: config.rgbLighting ? currentRgb : config.titleColor }}>
        {title}
      </h1>
      {showBadge && (
        <div className="inline-flex items-center gap-2 px-4 py-1 rounded-full text-[10px] font-black uppercase tracking-widest transition-all duration-300" style={{ backgroundColor: config.rgbLighting ? currentRgb : (config.darkMode ? 'white' : 'black'), color: config.rgbLighting ? (config.darkMode ? 'black' : 'white') : (config.darkMode ? 'black' : 'white') }}>
          {config.mode === 'SPAWNER' ? `${ballCount} Spheres` : (config.mode === 'ESCAPE' ? `${ringsLeft} Rings Left` : `${bounceCount} Bounces`)}
        </div>
      )}
    </div>
  );
};
